import React, { useEffect, useState } from "react";
import { Col, ListGroup, ListGroupItem, Row } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { listUserClinics } from "../actions/clinicActions";
import { notify } from "./notify";
import { Howl } from "howler";
import { CLINIC_CREATE_RESET } from "../constants/clinicConstants";
import Message from "./Message";
import { FaExternalLinkAlt, FaPlusCircle } from "react-icons/fa";
import ClinicForm from "./ClinicForm";

const ClinicList = () => {
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const clinicsOfUserStore = useSelector((state) => state.clinicsOfUserStore);
  const { noRequest, loading, userClinics, error } = clinicsOfUserStore;

  const clinicAddStore = useSelector((state) => state.clinicAddStore);
  const { loading: loadingNewClinic, newClinic } = clinicAddStore;

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (userInfo && noRequest) {
      dispatch(listUserClinics());
    }
  }, [noRequest, userInfo]);

  useEffect(() => {
    if (newClinic) {
      notify({
        title: "Clinic Success",
        message: `Your clinic is created successfully`,
        type: "success",
        duration: 3000,
      });
      var sound = new Howl({
        src: `/success.mp3`,
      });
      sound.play();
      dispatch({ type: CLINIC_CREATE_RESET });
    }
  }, [newClinic]);

  return (
    <div>
      {loadingNewClinic || loading ? (
        <Skeleton height="150px" className="mb-5" count={2} />
      ) : error ? (
        <Message children={`Get User Clinics: ${error}`} variant={`danger`} />
      ) : userClinics && userClinics.length === 0 ? (
        <Message
          children={`You have NO clinic yet. Kindly, add your first clinic below 👇`}
          variant={`info`}
        />
      ) : (
        userClinics?.map((c) => (
          <ListGroup key={c._id}>
            <ListGroupItem
              style={{
                backgroundColor: "#00abff",
              }}
              className=" mt-3 text-white border rounded"
            >
              <Row
                className="p-3"
                onClick={() => {
                  navigate(`/clinic-screen/${c._id}`);
                }}
              >
                <Col className="row justify-content-center">
                  <h1>{c.clinicName}</h1>
                </Col>
                <Col className="col-sm-4 align-self-center ">
                  <h1>
                    <FaExternalLinkAlt /> go
                  </h1>
                </Col>
              </Row>
            </ListGroupItem>
          </ListGroup>
        ))
      )}
      <Row className="text-center">
        <Col>
          <h3>
            <FaPlusCircle /> ADD NEW CLINIC
          </h3>
        </Col>
      </Row>
      <ClinicForm />
    </div>
  );
};

export default ClinicList;
